<div [ngClass]="{temporary: inMobileEditor}">
  @if (!isVideoPlaylist) {
    <div>
      @for (cont of container.containers | filterBy: {type:2 , isDraftMode: isDraftMode} | orderBy:'orderBy'; track cont) {
        <section class="content_section " [ngClass]="{dark: cont.isShaded == true}"
          id="section-{{cont.id}}" dndDropzone [dndDisableIf]="!(this.isFireFox || this.isEdge)"
          (dndDragover)="onDragover1($event)">
          <div class="page-title-wrapper" style="position: relative;">
            <h2 id="editor-title-{{cont.id}}" [inlineMenuId]="'container-menu-' + cont.id"
              [ngStyle]="{'font-size': (hideContent && inMobileEditor) ? '28px' : '52px' }"
              [ngClass]="{limitTitle: cont.previewImageId != null}" contenteditable="true" appCKEditor
              [innerHTML]="cont.title" (ckBlur)="updateSectionTitle($event,cont)">
            </h2>
            @if (cont.previewImageId != null) {
              <img
                [src]="getPreviewImage(cont.previewImageId) | loadSecureAssets  : true | async " class="section-preview-image"
                alt="" onerror="this.src = 'assets/img/loader.gif'" (load)="imageLoaded = true;" [hidden]="!imageLoaded" />
            }
            <div class="clear"></div>
          </div>
          <article id="pageSectionTargetElementSectionId" class="content-box dragDrop">
            @for (column of cont.contentColumns | orderBy:'order'; track column) {
              @if (!column.isDeleted && !isVideoPlaylist) {
                <app-content-box (updateSectionEvent)="updateSection($event)" [contentColumn]="column"
                  class="custom-col col edit-container grid-{{column.columnWidth}}" id="column-{{column.id}}"
                  [parentSectionId]="cont.id" [level]="0" [pageTemplateId]="pageTemplateId" [container]="container"
                  [hideContent]="hideContent" [reorderContent]="reorderContent">
                </app-content-box>
              }
              <div class="clear"></div>
            }
          </article>
        </section>
      }
    </div>
  }
</div>